/**
 * 第三方课件明细列表管理功能
 * @Author:wuTao
 * @Date 2020/09/15
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool, utils_tool } from '@/tool';
import { modelUtils } from '@/utils';
import { coursewareDetailColumns } from './columns'
import moment from "moment";

let { WizContainer } = framework_tool

let { Session, $$, checkStrLength, getPageData } = utils_tool;
let {
  WizRow, WizCol, WizTable, WizCard, WizSpin, WizTabs, WizButton,
  WizTag, WizSearchBar, WizDataTable, WizBrowserExport, WizModal
} = component_tool;

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
const getCoursewareInfoRecord = (history) => {
  let record = null
  if (history.location.record) {
    // 从location中取出record
    record = history.location.record;
    Session.set('coursewareInfoRecord', record);
  } else {
    record = Session.get('coursewareInfoRecord') || null
  }
  return record
}
class LookCourseware extends WizContainer {

  componentName = 'lookCourseware';

  constructor(props) {
    super(props);
    const { history } = props;
    this.state = {
      coursewareDetailKey: new Date().getTime(),
    };
    this.initialValue = getCoursewareInfoRecord(history);
    this.initialValue.coursewareDetailList = [];
  }

  _componentDidMount() {
    if (this.initialValue && this.initialValue.id) {
      //需初始化数据
      this.getCoursewareById();
    }
  }

  propsAndStateOnChange = {
    coursewareInfo: this._getCoursewareByIdOver.bind(this),
  };


  /**查看时时获取对应的第三方课件明细信息数据 */
  getCoursewareById() {
    this.doAction({
      path: 'coursewareManagement/selectOneById',
      payload: {
        key: 'coursewareManagement@selectOneById',
        apiParams: {
          id: this.initialValue.id,
        }
      }
    });
  }

  /**
   * 将查询到的评语考核内容明细数据
   */
  _getCoursewareByIdOver(nextProps, nextState) {
    let initialValue = nextProps.coursewareInfo.data;
    if (nextProps.coursewareInfo.code == 1 && initialValue && initialValue.coursewareDetailList && initialValue.coursewareDetailList.length > 0) {
      //重新排序
      initialValue.coursewareDetailList.sort(function (a, b) {
        if (!a['itemOrder'] || !b['itemOrder']) {
          return 0;
        }
        if (a['itemOrder'] < b['itemOrder']) {
          return -1;
        }
        if (a['itemOrder'] > b['itemOrder']) {
          return 1;
        }
        return 0;
      });
      let neoValue = Object.assign([]);
      if (initialValue.coursewareDetailList) {
        initialValue.coursewareDetailList.forEach(data => {
          const { itemOrder } = data;
          data.key = new Date().getTime() + itemOrder + '_commentDetail';
          neoValue.push(data);
        })
      }
      initialValue.coursewareDetailList = neoValue
      this.initialValue = initialValue;
    }
    return true;
  }

  _render() {
    const { coursewareManagementLoading } = this.props;
    let initialValue = this.initialValue;
    let other = {};
    let columns = coursewareDetailColumns(this, initialValue && initialValue.coursewareDetailList ? initialValue.coursewareDetailList : [], other);

    return (
      <>
        <WizSpin tip={'加载中'} spinning={coursewareManagementLoading}>
          <WizCard>
            <WizRow className='administrationScope-row-item'>
              <WizCol className='col-item' span={3} offset={1}><strong>{'名称' + '：'}</strong></WizCol>
              <WizCol span={16}>
                <span>{initialValue && initialValue.name ? initialValue.name : ''}</span>
              </WizCol>
            </WizRow>
            <WizRow className='administrationScope-row-item'>
              <WizCol className='col-item' span={3} offset={1}><strong>{'编码' + '：'}</strong></WizCol>
              <WizCol
                span={16}>{initialValue && initialValue.code ? initialValue.code : ''}</WizCol>
            </WizRow>
            <WizRow className='administrationScope-row-item'>
              <WizCol className='col-item' span={3} offset={1}><strong>{'平台' + '：'}</strong></WizCol>
              <WizCol
                span={16}>{initialValue && initialValue.channel && initialValue.channel === 1 ? 'scorm平台' : '未知'}</WizCol>
            </WizRow>
            <WizRow className='administrationScope-row-item'>
              <WizCol className='col-item' span={3} offset={1}><strong>{'更新时间' + '：'}</strong></WizCol>
              <WizCol
                span={16}>{initialValue && formatterDate(initialValue.updateTime)}</WizCol>
            </WizRow>
          </WizCard>
          <WizCard>
            <WizTabs animated={false}>
              <WizTabs.TabPane tab="章节内容" key={'courseware_detail'}>
                <WizTable pagination={false} key={this.state.coursewareDetailKey} columns={columns}
                  dataSource={initialValue && initialValue.coursewareDetailList ? initialValue.coursewareDetailList : []} />
              </WizTabs.TabPane>
            </WizTabs>
          </WizCard>
        </WizSpin>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { coursewareManagement } = state;
  const coursewareInfo = modelUtils.getModelEntity(coursewareManagement, "coursewareManagement@selectOneById");
  const load = modelUtils.getLoadingState(state, ['coursewareManagement']);
  return {
    coursewareInfo: coursewareInfo,
    ...load
  }
};

export default connect(mapStateToProps)(LookCourseware);
